import { render, staticRenderFns } from "./bip-values.vue?vue&type=template&id=3b84cc00&scoped=true&"
import script from "./bip-values.vue?vue&type=script&lang=js&"
export * from "./bip-values.vue?vue&type=script&lang=js&"
import style0 from "./bip-values.vue?vue&type=style&index=0&lang=css&"
import style1 from "./bip-values.vue?vue&type=style&index=1&id=3b84cc00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b84cc00",
  null
  
)

export default component.exports